
// @TODO: It's definitely should be refactored

import { Component, Emit, Prop, Vue } from 'nuxt-property-decorator'
import type { RatingStatModel } from '@alao-frontend/erp-services'
import { ExtendedProviderModel } from '~/core/offer.types'
import RatingStars from '~/components/sections/rating/RatingStars.vue'
import RatingBar from '~/components/sections/rating/RatingBar.vue'
import RatingServices from '~/components/sections/rating/RatingServices.vue'
import { AlButton } from '~/components/ui'

@Component({
  components: {
    AlButton,
    RatingStars,
    RatingBar,
    RatingServices,
  },
})
export default class ProviderRatingCard extends Vue {
  @Prop({ required: true })
  readonly provider!: ExtendedProviderModel

  @Prop({ required: true })
  readonly providerScores!: RatingStatModel

  @Prop({ required: false, default: false })
  readonly isShowCTA!: boolean

  @Prop({ required: false, default: '', type: String })
  private readonly ctaText!: string

  get providerRating () {
    return this.provider.rating || 0
  }

  @Emit('on-cta-click')
  onCTAClick () {
    return true
  }
}
